<script setup lang="ts">
import Icon from '~/assets/images/icons/person.svg'

type Props = {
  size?: number
}

withDefaults(defineProps<Props>(), {
  size: 20,
})
</script>

<template>
  <Icon :height="size" :width="size" />
</template>
